 
import React from 'react';
import AttributeOption from './AttributeOption';
import NoAttributeOption from './NoAttributeOption';
import SizeGuide from './SizeGuide';

function AttributeSection({
    name,
    label,
    values,
    selectedId,
    isFirst,
    skip,
    rows,
    productId,
    handleSelection,
    sizeGuide
}) {
    const displayName = isFirst ? name : label;

    const hasValues = values.length > 0;

    const foundValue = hasValues ? values.find(attribute => attribute.attributeValueId === selectedId) : '';

    const displayValue = foundValue ? foundValue.attributeValueName : `No ${displayName}`;

    return (
        <>
            {hasValues && (
                <>
                    <div className="attribute-name">
                        {displayName}: {displayValue}
                        {label === 'Size' && (
                            <>
                                <span
                                    className="icon size-guide"
                                    title="Size Guide"
                                    role="img"
                                    data-modal={`#size-guide-${sizeGuide}`}
                                    data-modal-title="Bridle Size Guide"
                                >
                                    <span className="sr-only">Size Guide</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M635.7 167.2L556.1 31.7c-8.8-15-28.3-20.1-43.5-11.5l-69 39.1L503.3 161c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L416 75l-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L333.2 122 278 153.3 337.8 255c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-59.7-101.7-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-27.9-47.5-55.2 31.3 59.7 101.7c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L84.9 262.9l-69 39.1C.7 310.7-4.6 329.8 4.2 344.8l79.6 135.6c8.8 15 28.3 20.1 43.5 11.5L624.1 210c15.2-8.6 20.4-27.8 11.6-42.8z"></path></svg>
                                </span>
                                <div id={`size-guide-${sizeGuide}`} className="jsHide">
                                    <SizeGuide type={sizeGuide} />
                                </div>
                            </>
                        )}
                    </div>

                    <ul
                        className={`button-selector input-group size-options ${skip ? 'disabled-attr' : ''}`}
                        data-cols={rows}
                        data-type="option"
                    >
                        {hasValues &&
                            values.map((item, index) => {
                                const attrName = `${name}-${label}-option`;
                                const id = `${label}-${index}`;

                                return (
                                    <li key={item.attributeValueId} data-id={item.attributeValueId}>
                                        <AttributeOption
                                            name={attrName}
                                            id={id}
                                            checked={item.attributeValueId === selectedId}
                                            available={typeof item.compatible === 'boolean' ? item.compatible : true}
                                            handleSelection={() => handleSelection(item)}
                                        >
                                            {item.attributeValueName} {label === 'Color' && name}
                                        </AttributeOption>
                                    </li>
                                );
                            })}

                        {isFirst && (
                            <li>
                                <NoAttributeOption
                                    name={`${name}-option`}
                                    id={`no-${name}`}
                                    productid={productId}
                                    handleSelection={() => handleSelection({})}
                                    available="true"
                                >
                                    No {name}
                                </NoAttributeOption>
                            </li>
                        )}
                    </ul>
                </>
            )}
        </>
    );
}

export default AttributeSection;
